import {err} from 'framework';
import type {Result, UseCase, ValidationError} from 'framework';
import type {NutritionPlan} from '../../domain/nutrition-plan';
import type {NutritionPlanError} from '../../domain/errors';
import type {
  NutritionPlanRepository,
  UpdateNutritionPlanInput,
} from '../ports/nutrition-plan.repository';
import type {UpdateNutritionPlanDataValidator} from '../validators/update-nutrition-plan-data.validator';

export class UpdateNutritionPlan implements UseCase<[UpdateNutritionPlanInput], NutritionPlan> {
  constructor(
    private readonly repository: NutritionPlanRepository,
    private readonly validator: UpdateNutritionPlanDataValidator,
  ) {}

  execute(
    input: UpdateNutritionPlanInput,
  ): Promise<Result<NutritionPlan, NutritionPlanError | ValidationError>> {
    const {planId, ...body} = input;
    // Validate the full form-shaped body when all primary fields are present;
    // otherwise skip form-shape validation and trust the partial patch.
    if (
      body.name !== undefined &&
      body.targets !== undefined &&
      body.startDate !== undefined &&
      body.endDate !== undefined
    ) {
      const validated = this.validator.validate({
        name: body.name,
        targets: body.targets,
        startDate: body.startDate,
        endDate: body.endDate,
      });
      if (!validated.ok) {
        return Promise.resolve(err(validated.error));
      }
      return this.repository.update({planId, ...validated.data});
    }

    return this.repository.update(input);
  }
}
